import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-lancamento-anexo-upload',
  templateUrl: './lancamento-anexo-upload.component.html',
  styleUrls: ['./lancamento-anexo-upload.component.scss']
})
export class LancamentoAnexoUploadComponent implements OnInit {


  public uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  hasAnotherDropZoneOver: boolean;
  response: string;
  queue$: BehaviorSubject<FileItem[]> = new BehaviorSubject<FileItem[]>(null);
  queue: FileItem[] = [];

  private destroy$ = new Subject<void>();

  lancamentoControle: number;



  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoAnexoUploadComponent>,
    private authService: JwtAuthService,
    private route: ActivatedRoute,
    private router: Router,
    private confirmService: AppConfirmService,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.lancamentoControle = this.data.payload.controle;
    let maxFileSize = 64 * 1024 * 1024;

    const url = `${this.authService.apiUrl}/lancamento/anexo/upload/one/${this.lancamentoControle}`;

    console.log('URL: ' + url);

    var token = this.authService.token || this.authService.getJwtToken();

    if (this.authService.item$?.value?.remoto && this.authService.item$?.value?.empresaRemota !== null
      && this.authService.item$?.value?.empresaRemota !== undefined && url.search(this.authService.item$?.value?.empresaRemota.urlApi) > -1) {
      token = this.authService.tokenRemoto || this.authService.getJwtTokenRemoto();
    }

    this.uploader = new FileUploader({
      url: url,
      headers: [{ name: 'Authorization', value: 'Bearer ' + token },
      { name: 'Access-Control-Allow-Origin', value: `${this.authService.apiUrl}` },
      { name: 'Access-Control-Allow-Methods', value: 'GET, POST, DELETE, PUT' },
      { name: 'Access-Control-Allow-Headers', value: 'Origin, X-Requested-With, Content-Type, Accept, Authorization' },
      { name: 'Access-Control-Allow-Credentials', value: 'true' },
        // {name: 'Access-Control-Allow-Methods', value: 'GET,POST'}, {name: 'Access-Control-Allow-Origin', value: '*'}
      ],
      maxFileSize: maxFileSize
    });

    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      let message = '';
      switch (filter.name) {
        case 'fileSize':
          message = 'Atenção ! \nArquivo adicionado \"' + item.name + '\" contém ' + this.formatBytes(item.size) + ', e excede o tamanho máximo permitido de: ' + this.formatBytes(maxFileSize);
          break;
        default:
          message = 'Error trying to upload file ' + item.name;
          break;
      }
      this.confirmService.confirm({
        title: 'ERRO AO ENVIAR ARQUIVO',
        message: message, error: true
      }).pipe(takeUntil(this.destroy$)).subscribe(doc => {
        console.log(doc);
      });
    };

    this.uploader.onCompleteItem = (fileItem: FileItem, response: any, status: number, headers: any) => {
      console.log('Upload complete', fileItem, status, response);
      this.onFileSelected();
    };

    this.uploader.onAfterAddingFile = (file) => { file.withCredentials = true; };
  }

  formatBytes(bytes, decimals?) {
    if (bytes == 0) return '0 Bytes';
    const k = 1024,
      dm = decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });
  }

  onFileSelected() {
    console.log('SELECIONANDO ARQUIVOS[' + this.uploader.queue.length + ']');
    this.queue = [...this.uploader.queue];
    this.queue$.next(this.uploader.queue);
    this.cdr.detectChanges();

  }


}
